<template>
  <div class="pipeline-steps">
    <div
      v-for="(step, i) in steps"
      :key="step.label"
      class="pipeline-steps-item"
      :class="{
        'is-current': i === currentStepIndex,
        'is-done': currentStepIndex !== null && i < currentStepIndex,
        'is-pending': currentStepIndex !== null && i > currentStepIndex,
      }"
    >
      <div class="pipeline-steps-node">
        <v-icon size="16" :class="{ 'spin-icon': i === currentStepIndex }">
          {{ i === currentStepIndex ? "mdi-autorenew" : step.icon }}
        </v-icon>
      </div>
      <span class="pipeline-steps-label">{{ step.label }}</span>
      <div v-if="i < steps.length - 1" class="pipeline-steps-connector"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PipelineSteps",
  props: {
    steps: { type: Array, required: true },
    currentStepIndex: { type: Number, default: null },
  },
};
</script>

<style src="./styles.scss" scoped lang="scss" />
